'use client';

import {alpha, Box, Button, Container, styled, Typography} from '@mui/material';


export const StyledTopicPageContainer = styled(Container)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  color: theme.palette.text.dark,
  padding: theme.spacing(6, 6),
  marginBottom: theme.spacing(4),
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    padding: theme.spacing(4, 4),
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    padding: theme.spacing(3, 3),
  },
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    padding: theme.spacing(2, 2),
  },
}));


export const StyledTopicPageContentContainer = styled(Container)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.text.dark,
  flex: 2
}));

export const StyledTopicPageTeaserContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.text.dark,
  flex: 1
}));

export const StyledTopicPageIntroBox = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
  maxWidth: 700
}));


export const StyledTopicPageTopicsContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.text.dark,
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadiusMd,
  backgroundImage: "url('/images/new-articles-background.png')",
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom right',
  alignSelf: 'flex-start',
  backgroundColor: theme.palette.background.white
}));

export const StyledTopicPageTeaserArticle = styled(Box)(({theme}) => ({
  paddingBottom: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${alpha(theme.palette.background.separator, 0.15)}`,
  position: 'relative',
  width: '85%',
  zIndex: 1,
  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

export const StyledTopicPageTeaserButton = Button;

export const StyledCtaAreaContainer = styled(Box)(({theme}) => ({
  background: theme.palette.background.grey,
  color: theme.palette.text.dark,
  padding: theme.spacing(4, 3),
  margin: theme.spacing(6, 0),
  borderRadius: theme.shape.borderRadiusLg,
}));

export const StyledTopicPageImageContainer = styled(Box)(({theme}) => ({
  borderRadius: theme.shape.borderRadiusLg,
  // necessary for next/image with `fill` to size itself correctly
  position: 'relative',
  width: '100%',
  // give a sensible default height; you can change to an aspect ratio if desired
  overflow: 'hidden',
  margin: theme.spacing(3, 0),
  
  height: 500,
  [theme.breakpoints.down('md')]: {
    height: 425,
  },
  [theme.breakpoints.down('sm')]: {
    height: 325,
  },
}));

export const StyledShareSectionContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(4),
  borderTop: `2px solid ${alpha(theme.palette.background.separator, 0.15)}`,
  paddingTop: theme.spacing(2),
}));

export const StyledTeaserCardsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

export const StyledTeaserCard = styled(Box)(({theme}) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusMd,
  height: 360,
  cursor: 'pointer',
  '&:hover img': {
    transform: 'scale(1.03)',
  },
  '& img': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 400ms ease',
  },
  '& .teaser-overlay': {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 70%)',
    zIndex: 1,
  },
  '& .teaser-content': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(1.2, 1.45),
    paddingRight: theme.spacing(5),
    zIndex: 2,
  },
  '& .teaser-arrow': {
    position: 'absolute',
    bottom: theme.spacing(1.2),
    right: theme.spacing(1.45),
    zIndex: 3,
    display: 'flex',
    flexShrink: 0,
    lineHeight: 0,
  },
  '& .teaser-content-text': {
    color: theme.palette.common.white,
  },
  '& .teaser-heading': {
    color: theme.palette.common.white,
  },
  '& .teaser-tag': {
    position: 'absolute',
    top: theme.spacing(1.5),
    left: theme.spacing(1.5),
    backgroundColor: theme.palette.tv4Grey.grey01,
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.shape.borderRadiusSm,
    zIndex: 2,
    fontSize: '0.75rem',
    fontWeight: 600,
  },
}));

export const StyledMediaCaption = styled(Typography)(({theme}) => ({
  marginTop: theme.spacing(-4),
  marginBottom: theme.spacing(2),
  display: 'block',
}));